import HomeRoutes from "../pages/home/Home.routes";
import AuthRoutes from "../pages/Login/auth.routes";
import WithdrawRoutes from "../pages/withdraw/withdraw.routes";
import VerificationRoutes from '../pages/verification/verification.routes';
import NotFoundRoutes from "../pages/not-found/NotFound.routes";
import MFARoutes from '../pages/mfa/mfa.routes';
import GettingStartedRoutes from '../pages/GettingStarted/GettingStarted.routes';
import RecurringPaymentRoutes from "../pages/RecurringPayment/recurringPayment.routes";
import StatementRoutes from "../pages/statements/statements.routes";
import BankRoutes from '../pages/bank/bank.routes';
import AccountsRoutes from "../pages/accounts/Accounts.routes";
import ReferRoutes from '../pages/Refer/Refer.routes';
import ReferRoutesSignup from "../pages/ReferrSignup/Refer.routes";
import VerificationSuccessRoutes from "../pages/verification/verificationSuccess.routes";

const routesConfig = [
    HomeRoutes,
    AuthRoutes,
    WithdrawRoutes,
    VerificationRoutes,
    NotFoundRoutes,
    MFARoutes,
    GettingStartedRoutes,
    RecurringPaymentRoutes,
    StatementRoutes,
    BankRoutes,
    AccountsRoutes,
    ReferRoutes,
    ReferRoutesSignup,
    VerificationSuccessRoutes
];

export default routesConfig;
